export default "__VITE_ASSET__CjQInatX__"